import {Field, useField, ErrorMessage} from 'formik';

const InputField = ({label, labelClass, className, ...otherProps}) => {
    const [field, meta, children] = useField(otherProps);
    const valid = meta.touched && !meta.error;
    const invalid = meta.touched && meta.error;

    return (
        <>
            <label className={labelClass} htmlFor={field.name}>{label}</label>
            {children ? (<Field
                className={`${className} ${invalid && 'is-invalid'} ${valid && 'is-valid'}`}
                autoComplete="off"
                {...field}
                {...otherProps}
            ></Field>) : (<Field
                className={`${className} ${invalid && 'is-invalid'} ${valid && 'is-valid'}`}
                autoComplete="off"
                {...field}
                {...otherProps}
            />)}
            
            <div>
                <ErrorMessage
                    component="span"
                    name={field.name}
                    className="help is-danger"
                />
            </div>
        </>
    )
}

export default InputField;